const en = {
  // menu
  menuAgentAi: "Agent AI",
  menuVoiceScenario: "Voice Scenario",
  menuAgentList: "Agent AI",
  menuRobocall: "Robocall",

  // robocall list page
  robocallListTitle: "Robocall",
  robocallListDescription:
    "Manage your outbound voice-bot scenarios, edit their call flow, and activate or deactivate them.",
  robocallCreateButton: "Create Robocall",
  robocallEmptyTitle: "No Robocall agents yet",
  robocallEmptyDescription:
    "Create your first Robocall agent to start building an outbound voice-bot scenario.",
  robocallCreateDialogTitle: "Create Robocall",
  robocallEditDialogTitle: "Edit Robocall",
  robocallCreateSuccess: "Robocall agent created.",
  robocallUpdateSuccess: "Robocall agent updated.",
  robocallSaveFailed: "Failed to save the scenario.",
  robocallListLoadFailed: "Failed to load Robocall agents.",

  // robocall scenario validation
  robocallValidationNoScenarioCode: "Scenario code is required.",
  robocallValidationBadInitialState:
    "Initial state must match one of the states.",
  robocallValidationDuplicateState: "Duplicate state name.",
  robocallValidationDisconnected:
    "State is not connected to the rest of the flow.",
  robocallValidationNoReachableHangUp:
    "No reachable Hang up — every path must end the call.",
  robocallValidationDeadAction: "Action after a terminal action never runs.",
  robocallValidationRefMissingState:
    "Action targets a state that does not exist.",
  robocallValidationRefNoConnection:
    "Action targets a state with no matching connection.",
  robocallValidationConnectionEndpointMissing:
    "Connection references a state that does not exist.",
  robocallValidationProviderPair:
    "Provider and provider prefix must be set together.",
  robocallValidationWsConfigMissing:
    "This scenario uses ask/NLU — set preferred provider and Dialogflow project.",
  robocallValidationVoiceAiRequired:
    "This scenario uses Read Name / Read Full Name with Voice AI — enable Voice AI in Scenario settings.",

  // agent ai list page
  agentAiListTitle: "Agent AI",
  agentAiListDescription:
    "Manage your AI voice agents, edit their voice scenario, and activate or deactivate them.",
  agentAiColName: "Name",
  agentAiColStatus: "Status",
  agentAiColLanguage: "Language",
  agentAiColUpdated: "Last Updated",
  agentAiColAction: "Action",
  agentAiStatusActive: "Active",
  agentAiStatusInactive: "Inactive",
  agentAiEmptyTitle: "No agents yet",
  agentAiEmptyDescription: "Agents created on the platform will appear here.",
  agentAiListLoadFailed: "Failed to load agent list.",
  agentAiDialogCancel: "Cancel",
  agentAiActivateDialogTitle: "Activate agent",
  agentAiDeactivateDialogTitle: "Deactivate agent",
  agentAiActivateDialogContent: 'Activate the agent "{0}"?',
  agentAiDeactivateDialogContent: 'Deactivate the agent "{0}"?',
  agentAiActivateDialogSubmit: "Activate",
  agentAiDeactivateDialogSubmit: "Deactivate",
  agentAiActivateSuccess: "Agent activated.",
  agentAiDeactivateSuccess: "Agent deactivated.",
  agentAiActionFailed: "Failed to update agent status.",

  // list filter row
  agentAiSearchLabel: "Search by name",
  agentAiFilterStatus: "Status",
  agentAiStatusAll: "All",
  agentAiListRowCount: "Rows",

  // action-button tooltips (list table)
  agentAiTooltipCreate: "Create a new agent",
  agentAiTooltipEditDiagram: "Edit scenario diagram",
  agentAiTooltipEditAgent: "Edit agent settings",
  agentAiTooltipActivate: "Activate agent",
  agentAiTooltipDeactivate: "Deactivate agent",
  agentAiDeactivateBlockedTooltip:
    "Can't deactivate: this agent is linked to campaign {0} ({1}). Remove it from the campaign before deactivating.",

  // agent create / edit metadata dialog
  agentAiCreateButton: "Create Agent",
  agentAiCreateDialogTitle: "Create agent",
  agentAiEditDialogTitle: "Edit agent",
  agentAiFormName: "Name",
  agentAiFormLanguage: "Primary language",
  agentAiFormVoiceId: "Voice ID",
  agentAiFormVoiceArtist: "Voice artist",
  agentAiFormVoiceSpeed: "Voice speed",
  agentAiVoiceSpeedHint:
    "Default 0.4. Preview uses the current voice, language, and speed.",
  agentAiSpeedSlowest: "Slowest",
  agentAiSpeedNormal: "Normal",
  agentAiSpeedFastest: "Fastest",
  agentAiLanguageHelp:
    "Prioritizes speech recognition & voice output. Agent stays multilingual.",
  agentAiVoiceHelp:
    "Multilingual at call time; each voice has a fixed character. Use Preview.",
  agentAiTimezoneHelp:
    "Drives time-aware prompts & default date ranges. IANA names only.",
  agentAiVoicePreview: "Preview",
  agentAiVoicePreviewNoVoice: "Select a voice artist first.",
  agentAiVoicePreviewPending: "Voice preview coming soon.",
  agentAiVoicePreviewFailed: "Failed to play voice preview.",
  agentAiFormTimezone: "Timezone",
  agentAiFormPublic: "Public",
  agentAiFormInboundTrunk: "Inbound trunk ID",
  agentAiFormOutboundTrunk: "Outbound trunk ID",
  agentAiFormRequired: "Required",
  agentAiFormSave: "Save",
  agentAiCreateSuccess: "Agent created.",
  agentAiUpdateSuccess: "Agent updated.",
  agentAiSaveFailed: "Failed to save agent.",

  // palette + node kinds
  voiceScenarioPaletteTitle: "Nodes",
  voiceScenarioNodeSay: "Say",
  voiceScenarioNodeSetVariable: "Set Session Variable",
  voiceScenarioNodeSwitch: "Switch",
  voiceScenarioNodeCallApi: "Call API",
  voiceScenarioNodeEndCall: "End Call",
  voiceScenarioNodeVoiceInput: "Voice Input",
  voiceScenarioNodeInterruption: "Interruption",
  voiceScenarioNodeLockLanguage: "Lock Language",
  voiceScenarioNodeDataFormatting: "Data Formatting",
  voiceScenarioNodeConnectionEvent: "On Connected",
  voiceScenarioNodeCompletionTrigger: "On Call Completion",
  voiceScenarioNodeCompletionFailed: "On Call Failed",
  voiceScenarioNodeAiAgent: "AI Agent",
  voiceScenarioNodeLlm: "LLM",
  voiceScenarioNodeDtmfCapture: "DTMF Capture",
  voiceScenarioNodeTransferCall: "Transfer Call",
  voiceScenarioNodeLog: "Log",

  // toolbar
  voiceScenarioToolbarUndo: "Undo",
  voiceScenarioToolbarRedo: "Redo",
  voiceScenarioToolbarZoomIn: "Zoom in",
  voiceScenarioToolbarZoomOut: "Zoom out",
  voiceScenarioToolbarFit: "Fit to screen",
  voiceScenarioToolbarFullscreen: "Full screen",
  voiceScenarioToolbarExitFullscreen: "Exit full screen",
  voiceScenarioToolbarDelete: "Delete selected",
  voiceScenarioToolbarReload: "Reload diagram",
  voiceScenarioToolbarAutoArrange: "Auto arrange",
  voiceScenarioToolbarValidate: "Validate",
  voiceScenarioToolbarSave: "Save",

  // config panel
  voiceScenarioNodeLabel: "Label",
  voiceScenarioSubnote: "Node Title",
  voiceScenarioNoConfig: "This node has no configuration.",
  voiceScenarioAgentName: "Scenario name",
  voiceScenarioConfigInput: "Input",
  voiceScenarioConfigOutput: "Output",
  voiceScenarioNoIncoming: "No incoming connection.",
  voiceScenarioNoOutgoing: "No outgoing connection.",
  voiceScenarioSave: "Save",
  voiceScenarioCancel: "Cancel",

  // say
  voiceScenarioSayText: "Text to say",
  voiceScenarioSayTextTooLong: "Text to say must be 1000 characters or fewer.",

  // session variable
  voiceScenarioVariableName: "Variable name",
  voiceScenarioVariableValue: "Variable value",
  voiceScenarioVariableConfigTitle: "Variable Configuration",
  voiceScenarioVariableConfigDescription:
    "Define a session variable you can reuse across your flow.",
  voiceScenarioVariableNameHint:
    "Name must be alphanumeric or underscore only (1-50 chars). Must NOT be a built-in like phone_number, this_node_input.",
  voiceScenarioVariableBuiltinNote:
    "Built-ins are reserved variables provided by the system. See docs under Session Variables for the complete list.",
  voiceScenarioVariableValueHint:
    "Value is a string (max 255 chars). You can reference other session values using {{variable_name}} such as {{phone_number}} or CSV columns.",

  // call api
  voiceScenarioApiMethod: "Method",
  voiceScenarioApiUrl: "URL",
  voiceScenarioApiHeaders: "Headers (JSON)",
  voiceScenarioApiHeadersInvalid: "Invalid JSON",
  voiceScenarioApiBody: "Payload (JSON)",
  voiceScenarioApiBodyInvalid: "Invalid JSON payload",
  voiceScenarioJsonBeautify: "Beautify",
  voiceScenarioJsonMinify: "Minify",
  voiceScenarioOutputType: "Output type",
  voiceScenarioOutputApiResult: "API Result",
  voiceScenarioOutputDtmf: "DTMF",
  voiceScenarioOutputThisNodeInput: "This Node Input",
  voiceScenarioOutputNone: "None",
  voiceScenarioOutputLlmResponse: "LLM Response (default)",
  voiceScenarioOutputUserMessage: "User Message",
  voiceScenarioOutputFullContext: "Full Context",
  voiceScenarioOutputFormattedResult: "Formatted Result",
  voiceScenarioConnectionRejected: "Connection not allowed.",

  // interruption
  voiceScenarioInterruptionEnabled: "Allow interruption",
  voiceScenarioInterruptionTitle: "Interruption Control Settings",
  voiceScenarioInterruptionDesc:
    "Control whether the agent can be interrupted by user speech. When enabled, the agent will stop speaking if the user starts talking. When disabled, the agent will continue speaking even if the user interrupts.",
  voiceScenarioInterruptionStatus: "Interruption Status",
  voiceScenarioInterruptionEnabledOption:
    "Enabled - Agent can be interrupted by user speech",
  voiceScenarioInterruptionDisabledOption:
    "Disabled - Agent will not be interrupted",

  // lock language
  voiceScenarioLockTitle: "Lock Language",
  voiceScenarioLockDesc:
    "Lock or release conversation language for AI Agent replies. The setting applies for the rest of the call until another Lock Language node runs.",
  voiceScenarioLockMode: "Mode",
  voiceScenarioLockOptionLock: "Lock to language",
  voiceScenarioLockOptionLockDesc:
    "Locks the AI Agent to reply only in the selected language for the rest of the call. Use Auto (multilingual) to release the lock and return to the agent primary language with multilingual behavior.",
  voiceScenarioLockOptionAuto: "Auto (multilingual)",
  voiceScenarioLockOptionAutoDesc:
    "Releases the flow language lock. The agent returns to its primary language setting and can respond in other languages when appropriate.",
  voiceScenarioLockLocale: "Response language",

  // data formatting
  voiceScenarioFormatTitle: "Formatting Configuration",
  voiceScenarioFormatDesc:
    "Configure how to format and transform data in your flow. Choose from predefined formats or create custom formulas.",
  voiceScenarioFormatType: "Format Type",
  voiceScenarioFormatPredefinedOption: "Predefined Format",
  voiceScenarioFormatCustomOption: "Custom Formula",
  voiceScenarioPredefinedFormat: "Predefined Format",
  voiceScenarioPredefinedType: "Predefined type",
  voiceScenarioCustomFormula: "Custom Formula",
  voiceScenarioCustomFunctions:
    "Available functions: UPPER, LOWER, TRIM, LEFT, RIGHT, MID, FIND, REPLACE, CONCATENATE, LEN, IF, CONTAINS, STARTSWITH",
  voiceScenarioCustomDocs:
    "📖 For sample usage and examples, see the Flow → Data Formatting Node.",
  voiceScenarioCustomVars:
    "💡 Note: You can use session variables like {{this_node_input}}, {{phone_number}}, etc. in your formula. Session variables will be replaced with their values before the formula is evaluated.",
  voiceScenarioInputSource: "Input Source:",
  voiceScenarioInputSourceExamples:
    "Examples: {{this_node_input}}, {{phone_number}}, {{last_agent_message}}, {{custom_variable}}",
  voiceScenarioTestTitle: "Test Your Formatting",
  voiceScenarioTestButton: "Test",
  voiceScenarioTestInput: "Test Input",
  voiceScenarioTestOutput: "Test Output",

  // failure
  voiceScenarioFailureCause: "Failure cause",
  voiceScenarioFailureCauseHint: "Branch outputs: busy, timeout, otherError",

  // ai-agent / llm
  voiceScenarioAiInstruction: "Instruction",
  voiceScenarioAiReturnToUser: "Return response to user",
  voiceScenarioAiRespondLabel: "Respond to user:",
  voiceScenarioAiRespondInfo:
    "Yes (AI Agent responses are always delivered to the user)",
  voiceScenarioLlmInstruction: "Prompt",

  // dtmf capture
  voiceScenarioDtmfTitle: "DTMF Capture Settings",
  voiceScenarioDtmfDesc:
    "Configure how the DTMF capture node will collect input from the caller.",
  voiceScenarioDtmfExpectedLength: "Expected Length",
  voiceScenarioDtmfExpectedLengthHint: "0 = no length limit (use terminator)",
  voiceScenarioDtmfTerminator: "Terminator Character",
  voiceScenarioDtmfTerminatorHint: "Character to end input (e.g., #, *)",
  voiceScenarioDtmfTimeout: "Timeout (seconds)",
  voiceScenarioDtmfTimeoutHint: "How long to wait for DTMF input",
  voiceScenarioDtmfOr: "OR",

  // transfer-call
  voiceScenarioTransferCallTo: "Transfer To (Phone Number)",
  voiceScenarioTransferCallToHint: "Phone number to forward the call to",

  // log
  voiceScenarioLogText: "Log content",
  voiceScenarioLogTextHint:
    "Text written to the call log. Supports {{variable}} references.",

  // switch
  voiceScenarioSwitchInput: "Switch input source",
  voiceScenarioSwitchConditions: "Switch Conditions",
  voiceScenarioSwitchConditionsHint:
    "Configure conditions to route the flow to different nodes based on input content or time-based rules.",
  voiceScenarioSwitchAddCondition: "Add Condition",
  voiceScenarioSwitchConditionLabel: "Label",
  voiceScenarioSwitchCondition: "Condition",
  voiceScenarioSwitchValue: "Value",
  voiceScenarioSwitchStart: "Start",
  voiceScenarioSwitchEnd: "End",
  voiceScenarioSwitchStartTime: "Start Time",
  voiceScenarioSwitchEndTime: "End Time",
  voiceScenarioSwitchTo: "to",
  voiceScenarioSwitchDaysOptional: "Days (optional):",
  voiceScenarioSwitchHour: "Hour",
  voiceScenarioSwitchTimezone: "Timezone",
  // condition type group + labels
  voiceScenarioSwitchGroupText: "Text Conditions",
  voiceScenarioSwitchGroupTime: "Time Conditions",
  voiceScenarioSwitchTypeContains: "Contains",
  voiceScenarioSwitchTypeMatch: "Match",
  voiceScenarioSwitchTypeStartsWith: "Starts With",
  voiceScenarioSwitchTypeEndsWith: "Ends With",
  voiceScenarioSwitchTypeRegex: "Regex",
  voiceScenarioSwitchTypeTimeRange: "Time Range",
  voiceScenarioSwitchTypeDayOfWeek: "Day of Week",
  voiceScenarioSwitchTypeHourComparison: "Hour Comparison",
  voiceScenarioSwitchFallbackHint:
    "A 'fallback' output is always available for unmatched conditions.",

  // validation
  voiceScenarioValidationTitle: "Validation",
  voiceScenarioValidationPassed: "No issues found.",
  voiceScenarioValidationStartHasIncoming:
    "A start/trigger node should not have incoming connections.",
  voiceScenarioValidationEndHasOutgoing:
    "An End Call node should not have outgoing connections.",
  voiceScenarioValidationDisconnected:
    "This node is not connected to anything.",
  voiceScenarioValidationEmptySay: "Say node has no text.",
  voiceScenarioValidationEmptyApiUrl: "Call API node has no URL.",

  // persistence
  voiceScenarioLoadFailed: "Failed to load scenario.",
  voiceScenarioSaveFailed: "Failed to save scenario.",
  voiceScenarioSaveSuccess: "Scenario saved.",
  voiceScenarioSaveNoAgent: "Create an agent before saving a scenario.",
  voiceScenarioUnsavedTitle: "Unsaved changes",
  voiceScenarioUnsavedContent:
    "You have unsaved changes. Leave without saving?",
  voiceScenarioUnsavedCancel: "Stay",
  voiceScenarioUnsavedConfirm: "Leave",
  voiceScenarioReloadTitle: "Reload diagram",
  voiceScenarioReloadContent:
    "Reloading discards your unsaved changes and restores the last saved version. Continue?",
  voiceScenarioReloadCancel: "Cancel",
  voiceScenarioReloadConfirm: "Reload",

  // delete node
  voiceScenarioDeleteNodeTitle: "Delete node",
  voiceScenarioDeleteNodeContent:
    "Remove this node from the scenario? This action cannot be undone.",
  voiceScenarioDeleteConfirm: "Delete",
  voiceScenarioDeleteCancel: "Cancel",

  // workspace tabs
  agentTabFlow: "Agent Flow",
  agentTabRag: "RAG Document",
  agentTabSentiment: "Sentiment Config",
  agentTabAgentConfig: "Agent Config",

  // agent config tab
  agentConfigTitle: "Agent Settings",
  agentConfigNoAgentHint: "Save the agent first to edit its settings.",

  // rag document tab
  ragSearchPlaceholder: "Search by document name",
  ragUpload: "Upload Document",
  ragColName: "Document Name",
  ragColType: "Type",
  ragColSize: "Size",
  ragColStatus: "Status",
  ragColUploadedAt: "Uploaded At",
  ragColActions: "Actions",
  ragEmptyTitle: "No documents yet",
  ragEmptyDescription: "Uploaded documents for this agent will appear here.",
  ragUploadSuccess: "Document uploaded.",
  ragUploadFailed: "Failed to upload document.",
  ragDeleteSuccess: "Document deleted.",
  ragDeleteFailed: "Failed to delete document.",
  ragResyncTooltip: "Resync status",
  ragResyncSuccess: "Document resynced.",
  ragResyncFailed: "Failed to resync document.",
  ragDeleteTooltip: "Delete document",
  ragLoadFailed: "Failed to load documents.",
  ragNoAgentHint: "Save this agent first to manage its documents.",
  ragDialogTitle: "Upload RAG Document",
  ragDialogNameLabel: "Document Name",
  ragDialogChooseFile: "Choose File",
  ragDialogFormatsLabel: "Supported formats:",
  ragDialogFormatsValue:
    "PDF, DOCX, PPTX, XLSX, HTML, EPUB, Images (JPG, PNG, GIF), TXT",
  ragDialogSizeLabel: "File size limit:",
  ragDialogSizeValue: "10MB",
  ragDialogCancel: "Cancel",
  ragDialogUpload: "Upload",
  ragDialogSizeExceeded: "File exceeds the 10MB size limit.",
  ragDetailTooltip: "View details",
  ragDetailTitle: "Document Details",
  ragDetailOriginalFile: "Original File",
  ragDetailIndexStatus: "Index Status",
  ragDetailDocId: "Document ID",
  ragDetailCreatedAt: "Created At",
  ragDetailUpdatedAt: "Updated At",
  ragDetailClose: "Close",
  ragDeleteConfirmTitle: "Delete document?",
  ragDeleteConfirmContent:
    "This will permanently delete the document from this agent's knowledge base. This action cannot be undone.",
  ragStatusGuideTooltip: "What do these statuses mean?",
  ragStatusGuideTitle: "Document Status",
  ragStatusGuideIntro:
    "Documents have two status fields that track different aspects of processing:",
  ragStatusGuideMainTitle: "Main Status",
  ragStatusGuideRagTitle: "RAG / Index Status",
  ragStatusMainPending: "Document is queued for processing.",
  ragStatusMainProcessing: "Document is being processed by the RAG service.",
  ragStatusMainProcessed:
    "Document has been successfully processed and is ready for search.",
  ragStatusMainFailed: "Document processing failed.",
  ragStatusRagPending: "Document is queued in the RAG service.",
  ragStatusRagProcessing: "Document is being processed by the RAG service.",
  ragStatusRagIndexed:
    "Document has been successfully indexed and is searchable.",
  ragStatusRagFailed: "Document processing failed in the RAG service.",
  ragStatusRagUnknown: "Status could not be determined.",

  // sentiment config tab
  sentimentEntriesTitle: "Sentiment Entries",
  sentimentScaleSize: "Scale Size",
  sentimentColScore: "Value",
  sentimentColLabel: "Label",
  sentimentColCriteria: "Criteria",
  sentimentSave: "Save",
  sentimentReset: "Reset to Default",
  sentimentSaveSuccess: "Sentiment configuration saved.",
  sentimentSaveFailed: "Failed to save sentiment configuration.",
  sentimentLoadFailed: "Failed to load sentiment configuration.",
  sentimentDeleteSuccess:
    "Sentiment configuration reset. The default 3-point scale will be used.",
  sentimentDeleteFailed: "Failed to reset sentiment configuration.",
  sentimentRequired: "This field is required.",
  sentimentEmpty: "Pick a scale size to configure sentiment entries.",
  sentimentNoAgentHint: "Save this agent first to configure sentiment.",
  sentimentInfoTooltip: "About sentiment configuration",
  sentimentInfoTitle: "About Sentiment Configuration",
  sentimentInfoIntro:
    "Sentiment configuration tells the AI how to rate the customer's mood during a conversation. Each score maps to a label and the criteria the AI uses to decide when that score applies.",
  sentimentInfoScaleTitle: "Scale size",
  sentimentInfoScaleDesc:
    "Choose a 3, 5, 7, or 10-point scale. A larger scale captures finer differences in mood but needs clearer criteria to keep each level distinct. Scores run from 1 (most negative) up to the scale size (most positive).",
  sentimentInfoCriteriaTitle: "Labels & criteria",
  sentimentInfoCriteriaDesc:
    'The label is the human-friendly name for a score (e.g. "Very Negative"). The criteria is the instruction the AI follows to assign that score — be specific about the emotions, words, or behaviour that belong to each level.',
  sentimentInfoDefaultTitle: "Default behaviour",
  sentimentInfoDefaultDesc:
    "If no configuration is saved, the platform uses a default 3-point scale (Negative, Neutral, Positive). Save your own configuration to override it, or reset at any time to return to the default.",
  sentimentInfoClose: "Got it",
  sentimentResetConfirmTitle: "Reset to default scale?",
  sentimentResetConfirmContent:
    "This deletes the saved sentiment configuration for this agent. This action cannot be undone.",
  sentimentResetConfirmHint:
    "After resetting, the agent falls back to the default 3-point scale (Negative, Neutral, Positive) until you save a new configuration.",
  sentimentResetConfirm: "Reset",
  // Live voice conversation test
  agentConversationButton: "Test Conversation",
  agentConversationTitle: "Voice Conversation",
  agentConversationInactiveTooltip:
    "Activate the agent to start a conversation",
  agentConversationStatusIdle: "Idle",
  agentConversationStatusConnecting: "Connecting…",
  agentConversationStatusActive: "Listening",
  agentConversationStatusError: "Error",
  agentConversationHintIdle: "Click green mic to start conversation",
  agentConversationHintConnecting: "Setting up conversation…",
  agentConversationHintActive: "Click the mic to end the conversation",
  agentConversationErrorConnect: "Failed to connect. Please try again.",
  agentConversationErrorToken: "Failed to get conversation token.",
  agentConversationErrorMic:
    "Microphone access denied. Allow mic access and try again.",
  agentConversationErrorRoom: "Failed to join the conversation room.",
  agentConversationUnsavedTitle: "Unsaved changes",
  agentConversationUnsavedContent:
    "You have unsaved changes to this flow. Testing runs against the last saved agent, so unsaved edits won't be reflected. Save first to test your latest changes.",
  agentConversationUnsavedCancel: "Cancel",
  agentConversationUnsavedConfirm: "Test Anyway",
};

const id: typeof en = {
  // menu
  menuAgentAi: "Agent AI",
  menuVoiceScenario: "Skenario Suara",
  menuAgentList: "Agent AI",
  menuRobocall: "Robocall",

  // robocall list page
  robocallListTitle: "Robocall",
  robocallListDescription:
    "Kelola skenario voice-bot outbound, ubah alur panggilan, dan aktifkan atau nonaktifkan.",
  robocallCreateButton: "Buat Robocall",
  robocallEmptyTitle: "Belum ada agen Robocall",
  robocallEmptyDescription:
    "Buat agen Robocall pertama untuk mulai menyusun skenario voice-bot outbound.",
  robocallCreateDialogTitle: "Buat Robocall",
  robocallEditDialogTitle: "Ubah Robocall",
  robocallCreateSuccess: "Agen Robocall dibuat.",
  robocallUpdateSuccess: "Agen Robocall diperbarui.",
  robocallSaveFailed: "Gagal menyimpan skenario.",
  robocallListLoadFailed: "Gagal memuat agen Robocall.",

  // robocall scenario validation
  robocallValidationNoScenarioCode: "Kode skenario wajib diisi.",
  robocallValidationBadInitialState:
    "State awal harus cocok dengan salah satu state.",
  robocallValidationDuplicateState: "Nama state ganda.",
  robocallValidationDisconnected: "State tidak terhubung dengan alur lainnya.",
  robocallValidationNoReachableHangUp:
    "Tidak ada Hang up yang dapat dicapai — setiap alur harus mengakhiri panggilan.",
  robocallValidationDeadAction:
    "Aksi setelah aksi terminal tidak akan pernah dijalankan.",
  robocallValidationRefMissingState: "Aksi menuju state yang tidak ada.",
  robocallValidationRefNoConnection:
    "Aksi menuju state tanpa koneksi yang cocok.",
  robocallValidationConnectionEndpointMissing:
    "Koneksi merujuk ke state yang tidak ada.",
  robocallValidationProviderPair:
    "Provider dan provider prefix harus diisi bersamaan.",
  robocallValidationWsConfigMissing:
    "Skenario ini memakai ask/NLU — isi preferred provider dan proyek Dialogflow.",
  robocallValidationVoiceAiRequired:
    "Skenario ini memakai Read Name / Read Full Name dengan Voice AI — aktifkan Voice AI di pengaturan Skenario.",

  // agent ai list page
  agentAiListTitle: "Agent AI",
  agentAiListDescription:
    "Kelola agen suara AI Anda, ubah skenario suaranya, serta aktifkan atau nonaktifkan.",
  agentAiColName: "Nama",
  agentAiColStatus: "Status",
  agentAiColLanguage: "Bahasa",
  agentAiColUpdated: "Terakhir Diperbarui",
  agentAiColAction: "Aksi",
  agentAiStatusActive: "Aktif",
  agentAiStatusInactive: "Nonaktif",
  agentAiEmptyTitle: "Belum ada agen",
  agentAiEmptyDescription: "Agen yang dibuat di platform akan muncul di sini.",
  agentAiListLoadFailed: "Gagal memuat daftar agen.",
  agentAiDialogCancel: "Batal",
  agentAiActivateDialogTitle: "Aktifkan agen",
  agentAiDeactivateDialogTitle: "Nonaktifkan agen",
  agentAiActivateDialogContent: 'Aktifkan agen "{0}"?',
  agentAiDeactivateDialogContent: 'Nonaktifkan agen "{0}"?',
  agentAiActivateDialogSubmit: "Aktifkan",
  agentAiDeactivateDialogSubmit: "Nonaktifkan",
  agentAiActivateSuccess: "Agen diaktifkan.",
  agentAiDeactivateSuccess: "Agen dinonaktifkan.",
  agentAiActionFailed: "Gagal memperbarui status agen.",

  // list filter row
  agentAiSearchLabel: "Cari berdasarkan nama",
  agentAiFilterStatus: "Status",
  agentAiStatusAll: "Semua",
  agentAiListRowCount: "Baris",

  // action-button tooltips (list table)
  agentAiTooltipCreate: "Buat agen baru",
  agentAiTooltipEditDiagram: "Ubah diagram skenario",
  agentAiTooltipEditAgent: "Ubah pengaturan agen",
  agentAiTooltipActivate: "Aktifkan agen",
  agentAiTooltipDeactivate: "Nonaktifkan agen",
  agentAiDeactivateBlockedTooltip:
    "Tidak dapat menonaktifkan: agen ini tertaut ke campaign {0} ({1}). Lepaskan dari campaign sebelum menonaktifkan.",

  // agent create / edit metadata dialog
  agentAiCreateButton: "Buat Agen",
  agentAiCreateDialogTitle: "Buat agen",
  agentAiEditDialogTitle: "Ubah agen",
  agentAiFormName: "Nama",
  agentAiFormLanguage: "Bahasa utama",
  agentAiFormVoiceId: "Voice ID",
  agentAiFormVoiceArtist: "Artis suara",
  agentAiFormVoiceSpeed: "Kecepatan suara",
  agentAiVoiceSpeedHint:
    "Default 0.4. Pratinjau memakai suara, bahasa, dan kecepatan saat ini.",
  agentAiSpeedSlowest: "Paling lambat",
  agentAiSpeedNormal: "Normal",
  agentAiSpeedFastest: "Paling cepat",
  agentAiLanguageHelp:
    "Memprioritaskan pengenalan suara & keluaran suara. Agen tetap multibahasa.",
  agentAiVoiceHelp:
    "Multibahasa saat panggilan; tiap suara punya karakter tetap. Gunakan Pratinjau.",
  agentAiTimezoneHelp:
    "Mengatur prompt berbasis waktu & rentang tanggal default. Hanya nama IANA.",
  agentAiVoicePreview: "Pratinjau",
  agentAiVoicePreviewNoVoice: "Pilih artis suara dulu.",
  agentAiVoicePreviewPending: "Pratinjau suara segera hadir.",
  agentAiVoicePreviewFailed: "Gagal memutar pratinjau suara.",
  agentAiFormTimezone: "Zona waktu",
  agentAiFormPublic: "Publik",
  agentAiFormInboundTrunk: "Inbound trunk ID",
  agentAiFormOutboundTrunk: "Outbound trunk ID",
  agentAiFormRequired: "Wajib diisi",
  agentAiFormSave: "Simpan",
  agentAiCreateSuccess: "Agen dibuat.",
  agentAiUpdateSuccess: "Agen diperbarui.",
  agentAiSaveFailed: "Gagal menyimpan agen.",

  // palette + node kinds
  voiceScenarioPaletteTitle: "Node",
  voiceScenarioNodeSay: "Ucapkan",
  voiceScenarioNodeSetVariable: "Atur Variabel Sesi",
  voiceScenarioNodeSwitch: "Percabangan",
  voiceScenarioNodeCallApi: "Panggil API",
  voiceScenarioNodeEndCall: "Akhiri Panggilan",
  voiceScenarioNodeVoiceInput: "Input Suara",
  voiceScenarioNodeInterruption: "Interupsi",
  voiceScenarioNodeLockLanguage: "Kunci Bahasa",
  voiceScenarioNodeDataFormatting: "Format Data",
  voiceScenarioNodeConnectionEvent: "Saat Terhubung",
  voiceScenarioNodeCompletionTrigger: "Saat Panggilan Selesai",
  voiceScenarioNodeCompletionFailed: "Saat Panggilan Gagal",
  voiceScenarioNodeAiAgent: "Agen AI",
  voiceScenarioNodeLlm: "LLM",
  voiceScenarioNodeDtmfCapture: "Tangkap DTMF",
  voiceScenarioNodeTransferCall: "Transfer Panggilan",
  voiceScenarioNodeLog: "Log",

  // toolbar
  voiceScenarioToolbarUndo: "Urungkan",
  voiceScenarioToolbarRedo: "Ulangi",
  voiceScenarioToolbarZoomIn: "Perbesar",
  voiceScenarioToolbarZoomOut: "Perkecil",
  voiceScenarioToolbarFit: "Sesuaikan layar",
  voiceScenarioToolbarFullscreen: "Layar penuh",
  voiceScenarioToolbarExitFullscreen: "Keluar layar penuh",
  voiceScenarioToolbarDelete: "Hapus terpilih",
  voiceScenarioToolbarReload: "Muat ulang diagram",
  voiceScenarioToolbarAutoArrange: "Atur otomatis",
  voiceScenarioToolbarValidate: "Validasi",
  voiceScenarioToolbarSave: "Simpan",

  // config panel
  voiceScenarioNodeLabel: "Label",
  voiceScenarioSubnote: "Judul Node",
  voiceScenarioNoConfig: "Node ini tidak memiliki konfigurasi.",
  voiceScenarioAgentName: "Nama skenario",
  voiceScenarioConfigInput: "Input",
  voiceScenarioConfigOutput: "Output",
  voiceScenarioNoIncoming: "Tidak ada koneksi masuk.",
  voiceScenarioNoOutgoing: "Tidak ada koneksi keluar.",
  voiceScenarioSave: "Simpan",
  voiceScenarioCancel: "Batal",

  // say
  voiceScenarioSayText: "Teks yang diucapkan",
  voiceScenarioSayTextTooLong: "Teks yang diucapkan maksimal 1000 karakter.",

  // session variable
  voiceScenarioVariableName: "Nama variabel",
  voiceScenarioVariableValue: "Nilai variabel",
  voiceScenarioVariableConfigTitle: "Konfigurasi Variabel",
  voiceScenarioVariableConfigDescription:
    "Tentukan variabel sesi yang dapat digunakan kembali di seluruh alur Anda.",
  voiceScenarioVariableNameHint:
    "Nama hanya boleh alfanumerik atau garis bawah (1-50 karakter). TIDAK boleh berupa built-in seperti phone_number, this_node_input.",
  voiceScenarioVariableBuiltinNote:
    "Built-in adalah variabel khusus yang disediakan sistem. Lihat dokumentasi pada bagian Session Variables untuk daftar lengkapnya.",
  voiceScenarioVariableValueHint:
    "Nilai berupa teks (maks 255 karakter). Anda dapat mereferensikan nilai sesi lain menggunakan {{variable_name}} seperti {{phone_number}} atau kolom CSV.",

  // call api
  voiceScenarioApiMethod: "Metode",
  voiceScenarioApiUrl: "URL",
  voiceScenarioApiHeaders: "Header (JSON)",
  voiceScenarioApiHeadersInvalid: "JSON tidak valid",
  voiceScenarioApiBody: "Payload (JSON)",
  voiceScenarioApiBodyInvalid: "Payload JSON tidak valid",
  voiceScenarioJsonBeautify: "Rapikan",
  voiceScenarioJsonMinify: "Ringkas",
  voiceScenarioOutputType: "Tipe output",
  voiceScenarioOutputApiResult: "Hasil API",
  voiceScenarioOutputDtmf: "DTMF",
  voiceScenarioOutputThisNodeInput: "Input Node Ini",
  voiceScenarioOutputNone: "Tidak Ada",
  voiceScenarioOutputLlmResponse: "Respons LLM (default)",
  voiceScenarioOutputUserMessage: "Pesan Pengguna",
  voiceScenarioOutputFullContext: "Konteks Penuh",
  voiceScenarioOutputFormattedResult: "Hasil Format",
  voiceScenarioConnectionRejected: "Koneksi tidak diizinkan.",

  // interruption
  voiceScenarioInterruptionEnabled: "Izinkan interupsi",
  voiceScenarioInterruptionTitle: "Pengaturan Kontrol Interupsi",
  voiceScenarioInterruptionDesc:
    "Atur apakah agen dapat diinterupsi oleh ucapan pengguna. Jika diaktifkan, agen akan berhenti berbicara saat pengguna mulai berbicara. Jika dinonaktifkan, agen akan tetap berbicara meskipun pengguna menginterupsi.",
  voiceScenarioInterruptionStatus: "Status Interupsi",
  voiceScenarioInterruptionEnabledOption:
    "Aktif - Agen dapat diinterupsi oleh ucapan pengguna",
  voiceScenarioInterruptionDisabledOption:
    "Nonaktif - Agen tidak akan diinterupsi",

  // lock language
  voiceScenarioLockTitle: "Kunci Bahasa",
  voiceScenarioLockDesc:
    "Kunci atau lepaskan bahasa percakapan untuk balasan AI Agent. Pengaturan ini berlaku selama sisa panggilan hingga node Kunci Bahasa lain dijalankan.",
  voiceScenarioLockMode: "Mode",
  voiceScenarioLockOptionLock: "Kunci ke bahasa",
  voiceScenarioLockOptionLockDesc:
    "Mengunci AI Agent untuk hanya membalas dalam bahasa terpilih selama sisa panggilan. Gunakan Auto (multibahasa) untuk melepas kunci dan kembali ke bahasa utama agen dengan perilaku multibahasa.",
  voiceScenarioLockOptionAuto: "Auto (multibahasa)",
  voiceScenarioLockOptionAutoDesc:
    "Melepas kunci bahasa alur. Agen kembali ke pengaturan bahasa utamanya dan dapat merespons dalam bahasa lain bila sesuai.",
  voiceScenarioLockLocale: "Bahasa respons",

  // data formatting
  voiceScenarioFormatTitle: "Konfigurasi Format",
  voiceScenarioFormatDesc:
    "Atur cara memformat dan mengubah data dalam alur Anda. Pilih dari format bawaan atau buat formula khusus.",
  voiceScenarioFormatType: "Tipe Format",
  voiceScenarioFormatPredefinedOption: "Format Bawaan",
  voiceScenarioFormatCustomOption: "Formula Khusus",
  voiceScenarioPredefinedFormat: "Format Bawaan",
  voiceScenarioPredefinedType: "Tipe bawaan",
  voiceScenarioCustomFormula: "Formula Khusus",
  voiceScenarioCustomFunctions:
    "Fungsi tersedia: UPPER, LOWER, TRIM, LEFT, RIGHT, MID, FIND, REPLACE, CONCATENATE, LEN, IF, CONTAINS, STARTSWITH",
  voiceScenarioCustomDocs:
    "📖 Untuk contoh penggunaan, lihat Flow → Node Data Formatting.",
  voiceScenarioCustomVars:
    "💡 Catatan: Anda dapat memakai variabel sesi seperti {{this_node_input}}, {{phone_number}}, dll. dalam formula. Variabel sesi akan diganti dengan nilainya sebelum formula dievaluasi.",
  voiceScenarioInputSource: "Sumber Input:",
  voiceScenarioInputSourceExamples:
    "Contoh: {{this_node_input}}, {{phone_number}}, {{last_agent_message}}, {{custom_variable}}",
  voiceScenarioTestTitle: "Uji Format Anda",
  voiceScenarioTestButton: "Uji",
  voiceScenarioTestInput: "Input Uji",
  voiceScenarioTestOutput: "Output Uji",

  // failure
  voiceScenarioFailureCause: "Penyebab kegagalan",
  voiceScenarioFailureCauseHint: "Output cabang: busy, timeout, otherError",

  // ai-agent / llm
  voiceScenarioAiInstruction: "Instruksi",
  voiceScenarioAiReturnToUser: "Kembalikan respons ke pengguna",
  voiceScenarioAiRespondLabel: "Respons ke pengguna:",
  voiceScenarioAiRespondInfo:
    "Ya (respons AI Agent selalu dikirimkan ke pengguna)",
  voiceScenarioLlmInstruction: "Prompt",

  // dtmf capture
  voiceScenarioDtmfTitle: "Pengaturan Tangkap DTMF",
  voiceScenarioDtmfDesc:
    "Atur bagaimana node tangkap DTMF mengumpulkan input dari penelepon.",
  voiceScenarioDtmfExpectedLength: "Panjang yang diharapkan",
  voiceScenarioDtmfExpectedLengthHint:
    "0 = tanpa batas panjang (gunakan terminator)",
  voiceScenarioDtmfTerminator: "Karakter terminator",
  voiceScenarioDtmfTerminatorHint:
    "Karakter untuk mengakhiri input (mis. #, *)",
  voiceScenarioDtmfTimeout: "Batas waktu (detik)",
  voiceScenarioDtmfTimeoutHint: "Berapa lama menunggu input DTMF",
  voiceScenarioDtmfOr: "ATAU",

  // transfer-call
  voiceScenarioTransferCallTo: "Transfer Ke (Nomor Telepon)",
  voiceScenarioTransferCallToHint: "Nomor telepon tujuan transfer panggilan",

  // log
  voiceScenarioLogText: "Isi log",
  voiceScenarioLogTextHint:
    "Teks yang ditulis ke log panggilan. Mendukung referensi {{variable}}.",

  // switch
  voiceScenarioSwitchInput: "Sumber input percabangan",
  voiceScenarioSwitchConditions: "Kondisi Percabangan",
  voiceScenarioSwitchConditionsHint:
    "Atur kondisi untuk mengarahkan alur ke node berbeda berdasarkan isi input atau aturan berbasis waktu.",
  voiceScenarioSwitchAddCondition: "Tambah Kondisi",
  voiceScenarioSwitchConditionLabel: "Label",
  voiceScenarioSwitchCondition: "Kondisi",
  voiceScenarioSwitchValue: "Nilai",
  voiceScenarioSwitchStart: "Mulai",
  voiceScenarioSwitchEnd: "Selesai",
  voiceScenarioSwitchStartTime: "Waktu Mulai",
  voiceScenarioSwitchEndTime: "Waktu Selesai",
  voiceScenarioSwitchTo: "sampai",
  voiceScenarioSwitchDaysOptional: "Hari (opsional):",
  voiceScenarioSwitchHour: "Jam",
  voiceScenarioSwitchTimezone: "Zona waktu",
  // condition type group + labels
  voiceScenarioSwitchGroupText: "Kondisi Teks",
  voiceScenarioSwitchGroupTime: "Kondisi Waktu",
  voiceScenarioSwitchTypeContains: "Mengandung",
  voiceScenarioSwitchTypeMatch: "Sama Persis",
  voiceScenarioSwitchTypeStartsWith: "Diawali",
  voiceScenarioSwitchTypeEndsWith: "Diakhiri",
  voiceScenarioSwitchTypeRegex: "Regex",
  voiceScenarioSwitchTypeTimeRange: "Rentang Waktu",
  voiceScenarioSwitchTypeDayOfWeek: "Hari",
  voiceScenarioSwitchTypeHourComparison: "Perbandingan Jam",
  voiceScenarioSwitchFallbackHint:
    "Output 'fallback' selalu tersedia untuk kondisi yang tidak cocok.",

  // validation
  voiceScenarioValidationTitle: "Validasi",
  voiceScenarioValidationPassed: "Tidak ada masalah.",
  voiceScenarioValidationStartHasIncoming:
    "Node mulai/pemicu tidak boleh memiliki koneksi masuk.",
  voiceScenarioValidationEndHasOutgoing:
    "Node Akhiri Panggilan tidak boleh memiliki koneksi keluar.",
  voiceScenarioValidationDisconnected: "Node ini tidak terhubung ke apa pun.",
  voiceScenarioValidationEmptySay: "Node Ucapkan tidak memiliki teks.",
  voiceScenarioValidationEmptyApiUrl: "Node Panggil API tidak memiliki URL.",

  // persistence
  voiceScenarioLoadFailed: "Gagal memuat skenario.",
  voiceScenarioSaveFailed: "Gagal menyimpan skenario.",
  voiceScenarioSaveSuccess: "Skenario disimpan.",
  voiceScenarioSaveNoAgent:
    "Buat agen terlebih dahulu sebelum menyimpan skenario.",
  voiceScenarioUnsavedTitle: "Perubahan belum disimpan",
  voiceScenarioUnsavedContent:
    "Ada perubahan yang belum disimpan. Tinggalkan tanpa menyimpan?",
  voiceScenarioUnsavedCancel: "Tetap di sini",
  voiceScenarioUnsavedConfirm: "Tinggalkan",
  voiceScenarioReloadTitle: "Muat ulang diagram",
  voiceScenarioReloadContent:
    "Memuat ulang akan membuang perubahan yang belum disimpan dan mengembalikan versi tersimpan terakhir. Lanjutkan?",
  voiceScenarioReloadCancel: "Batal",
  voiceScenarioReloadConfirm: "Muat ulang",

  // delete node
  voiceScenarioDeleteNodeTitle: "Hapus node",
  voiceScenarioDeleteNodeContent:
    "Hapus node ini dari skenario? Tindakan ini tidak dapat dibatalkan.",
  voiceScenarioDeleteConfirm: "Hapus",
  voiceScenarioDeleteCancel: "Batal",

  // workspace tabs
  agentTabFlow: "Alur Agen",
  agentTabRag: "Dokumen RAG",
  agentTabSentiment: "Konfigurasi Sentimen",
  agentTabAgentConfig: "Konfigurasi Agen",

  // agent config tab
  agentConfigTitle: "Pengaturan Agen",
  agentConfigNoAgentHint:
    "Simpan agen terlebih dahulu untuk mengubah pengaturannya.",

  // rag document tab
  ragSearchPlaceholder: "Cari berdasarkan nama dokumen",
  ragUpload: "Unggah Dokumen",
  ragColName: "Nama Dokumen",
  ragColType: "Tipe",
  ragColSize: "Ukuran",
  ragColStatus: "Status",
  ragColUploadedAt: "Diunggah Pada",
  ragColActions: "Aksi",
  ragEmptyTitle: "Belum ada dokumen",
  ragEmptyDescription:
    "Dokumen yang diunggah untuk agen ini akan muncul di sini.",
  ragUploadSuccess: "Dokumen diunggah.",
  ragUploadFailed: "Gagal mengunggah dokumen.",
  ragDeleteSuccess: "Dokumen dihapus.",
  ragDeleteFailed: "Gagal menghapus dokumen.",
  ragResyncTooltip: "Sinkron ulang status",
  ragResyncSuccess: "Dokumen disinkron ulang.",
  ragResyncFailed: "Gagal menyinkron ulang dokumen.",
  ragDeleteTooltip: "Hapus dokumen",
  ragLoadFailed: "Gagal memuat dokumen.",
  ragNoAgentHint: "Simpan agen ini terlebih dahulu untuk mengelola dokumennya.",
  ragDialogTitle: "Unggah Dokumen RAG",
  ragDialogNameLabel: "Nama Dokumen",
  ragDialogChooseFile: "Pilih Berkas",
  ragDialogFormatsLabel: "Format yang didukung:",
  ragDialogFormatsValue:
    "PDF, DOCX, PPTX, XLSX, HTML, EPUB, Gambar (JPG, PNG, GIF), TXT",
  ragDialogSizeLabel: "Batas ukuran berkas:",
  ragDialogSizeValue: "10MB",
  ragDialogCancel: "Batal",
  ragDialogUpload: "Unggah",
  ragDialogSizeExceeded: "Berkas melebihi batas ukuran 10MB.",
  ragDetailTooltip: "Lihat detail",
  ragDetailTitle: "Detail Dokumen",
  ragDetailOriginalFile: "Berkas Asli",
  ragDetailIndexStatus: "Status Indeks",
  ragDetailDocId: "ID Dokumen",
  ragDetailCreatedAt: "Dibuat Pada",
  ragDetailUpdatedAt: "Diperbarui Pada",
  ragDetailClose: "Tutup",
  ragDeleteConfirmTitle: "Hapus dokumen?",
  ragDeleteConfirmContent:
    "Ini akan menghapus dokumen secara permanen dari basis pengetahuan agen ini. Tindakan ini tidak dapat dibatalkan.",
  ragStatusGuideTooltip: "Apa arti status ini?",
  ragStatusGuideTitle: "Status Dokumen",
  ragStatusGuideIntro:
    "Dokumen memiliki dua kolom status yang melacak aspek pemrosesan yang berbeda:",
  ragStatusGuideMainTitle: "Status Utama",
  ragStatusGuideRagTitle: "Status RAG / Indeks",
  ragStatusMainPending: "Dokumen sedang mengantre untuk diproses.",
  ragStatusMainProcessing: "Dokumen sedang diproses oleh layanan RAG.",
  ragStatusMainProcessed: "Dokumen berhasil diproses dan siap untuk pencarian.",
  ragStatusMainFailed: "Pemrosesan dokumen gagal.",
  ragStatusRagPending: "Dokumen sedang mengantre di layanan RAG.",
  ragStatusRagProcessing: "Dokumen sedang diproses oleh layanan RAG.",
  ragStatusRagIndexed: "Dokumen berhasil diindeks dan dapat dicari.",
  ragStatusRagFailed: "Pemrosesan dokumen gagal di layanan RAG.",
  ragStatusRagUnknown: "Status tidak dapat ditentukan.",

  // sentiment config tab
  sentimentEntriesTitle: "Entri Sentimen",
  sentimentScaleSize: "Ukuran Skala",
  sentimentColScore: "Nilai",
  sentimentColLabel: "Label",
  sentimentColCriteria: "Kriteria",
  sentimentSave: "Simpan",
  sentimentReset: "Setel Ulang ke Default",
  sentimentSaveSuccess: "Konfigurasi sentimen disimpan.",
  sentimentSaveFailed: "Gagal menyimpan konfigurasi sentimen.",
  sentimentLoadFailed: "Gagal memuat konfigurasi sentimen.",
  sentimentDeleteSuccess:
    "Konfigurasi sentimen disetel ulang. Skala default 3 poin akan digunakan.",
  sentimentDeleteFailed: "Gagal menyetel ulang konfigurasi sentimen.",
  sentimentRequired: "Bidang ini wajib diisi.",
  sentimentEmpty: "Pilih ukuran skala untuk mengatur entri sentimen.",
  sentimentNoAgentHint:
    "Simpan agen ini terlebih dahulu untuk mengatur sentimen.",
  sentimentInfoTooltip: "Tentang konfigurasi sentimen",
  sentimentInfoTitle: "Tentang Konfigurasi Sentimen",
  sentimentInfoIntro:
    "Konfigurasi sentimen memberi tahu AI cara menilai suasana hati pelanggan selama percakapan. Setiap skor dipetakan ke label dan kriteria yang digunakan AI untuk menentukan kapan skor tersebut berlaku.",
  sentimentInfoScaleTitle: "Ukuran skala",
  sentimentInfoScaleDesc:
    "Pilih skala 3, 5, 7, atau 10 poin. Skala yang lebih besar menangkap perbedaan suasana hati yang lebih halus tetapi membutuhkan kriteria yang lebih jelas agar setiap tingkat tetap berbeda. Skor berkisar dari 1 (paling negatif) hingga ukuran skala (paling positif).",
  sentimentInfoCriteriaTitle: "Label & kriteria",
  sentimentInfoCriteriaDesc:
    'Label adalah nama yang mudah dipahami untuk sebuah skor (mis. "Sangat Negatif"). Kriteria adalah instruksi yang diikuti AI untuk menetapkan skor tersebut — jelaskan secara spesifik emosi, kata, atau perilaku yang termasuk pada setiap tingkat.',
  sentimentInfoDefaultTitle: "Perilaku default",
  sentimentInfoDefaultDesc:
    "Jika tidak ada konfigurasi yang disimpan, platform menggunakan skala default 3 poin (Negatif, Netral, Positif). Simpan konfigurasi Anda sendiri untuk menggantinya, atau setel ulang kapan saja untuk kembali ke default.",
  sentimentInfoClose: "Mengerti",
  sentimentResetConfirmTitle: "Setel ulang ke skala default?",
  sentimentResetConfirmContent:
    "Ini akan menghapus konfigurasi sentimen yang tersimpan untuk agen ini. Tindakan ini tidak dapat dibatalkan.",
  sentimentResetConfirmHint:
    "Setelah disetel ulang, agen akan kembali ke skala default 3 poin (Negatif, Netral, Positif) hingga Anda menyimpan konfigurasi baru.",
  sentimentResetConfirm: "Setel Ulang",
  // Live voice conversation test
  agentConversationButton: "Uji Percakapan",
  agentConversationTitle: "Percakapan Suara",
  agentConversationInactiveTooltip: "Aktifkan agen untuk memulai percakapan",
  agentConversationStatusIdle: "Diam",
  agentConversationStatusConnecting: "Menghubungkan…",
  agentConversationStatusActive: "Mendengarkan",
  agentConversationStatusError: "Kesalahan",
  agentConversationHintIdle: "Klik mikrofon hijau untuk memulai percakapan",
  agentConversationHintConnecting: "Menyiapkan percakapan…",
  agentConversationHintActive: "Klik mikrofon untuk mengakhiri percakapan",
  agentConversationErrorConnect: "Gagal terhubung. Silakan coba lagi.",
  agentConversationErrorToken: "Gagal mendapatkan token percakapan.",
  agentConversationErrorMic:
    "Akses mikrofon ditolak. Izinkan akses mikrofon lalu coba lagi.",
  agentConversationErrorRoom: "Gagal bergabung ke ruang percakapan.",
  agentConversationUnsavedTitle: "Perubahan belum disimpan",
  agentConversationUnsavedContent:
    "Anda memiliki perubahan yang belum disimpan pada alur ini. Pengujian menggunakan agen yang terakhir disimpan, sehingga perubahan yang belum disimpan tidak akan diterapkan. Simpan terlebih dahulu untuk menguji perubahan terbaru Anda.",
  agentConversationUnsavedCancel: "Batal",
  agentConversationUnsavedConfirm: "Tetap Uji",
};

export default { id, en };
